import * as angular from 'angular';

import {react2angular} from "react2angular";

import {Eventlog} from '../components/ContractEventlog';

const ngModule = angular.module('reactEventlogModule', [])
    .component('reactEventlog', react2angular(Eventlog, [],
        ["$routeParams", 'server', 'security', 'nvdbapi', 'datacatalog', '$location', '$q', '$rootScope']));

const reactEventlogModuleName = ngModule.name;
export default reactEventlogModuleName;
